// Área CONTAS Meta Ads.
// KPIs, 5 filtros dropdown (Situação, Tipo, Gestor, Status, Qualidade), busca,
// células editáveis, badges de status, add/del — tudo ligado ao Supabase.
import { kpiHTML, drop, buildTable } from './shared.js'
import { hojeBR } from '../lib/format.js'
import { state, posicaoTopo } from '../store.js'
import { contasRepo, contaValorColuna, CONTA_COL } from '../data/repositories.js'

// Opções dos selects/filtros (idênticas ao legado).
const STATUS_OPTS = ['Aquecer', 'Em engajamento', 'Em conversão white', 'Em conversão black']
const SIT_OPTS = ['ATIVO', 'CAIU', 'PAUSADA']
export const GESTOR_OPTS = ['Gabriel', 'Ian', 'Gustavo', 'Andre', 'Victor']
const QUAL_OPTS = ['Não gasta', 'Gastado', 'Com bug']
const TIPO_OPTS = ['Normal', 'Alugada']

// Estado local de busca/filtros.
let contasSearch = '',
  fStatus = '',
  fSit = '',
  fGestor = '',
  fQual = '',
  fTipo = ''

let toast = () => {}
export function setToast(fn) {
  toast = fn
}

// Lista de IDs de oferta (para o dynselect de "Offer").
function ofertasIds() {
  return state.ofertas.map(o => (o.codigo || '').trim()).filter(Boolean)
}

// Filtro combinado (situação/tipo/status/gestor/qualidade).
function contasFilterFn(c) {
  if (fSit && (c.status || '').trim().toUpperCase() !== fSit.toUpperCase()) return false
  if (fTipo && (c.tipo || '').trim().toLowerCase() !== fTipo.toLowerCase()) return false
  if (fStatus && (c.situacao || '').trim() !== fStatus) return false
  if (fGestor && (c.gestor || '').trim() !== fGestor) return false
  if (fQual && (c.qualidade || '').trim() !== fQual) return false
  return true
}

// Carimba a data de hoje ao editar (campo `data`), como no legado (dateCol=8).
function stamp(c) {
  c.data = hojeBR()
}

// Persiste um campo da conta no Supabase.
async function persistir(c, campo) {
  if (!c.id) return
  try {
    const patch = { [CONTA_COL[campo]]: contaValorColuna(campo, c[campo]) }
    // ao carimbar a data, também grava a coluna data
    if (CONTA_COL.data && campo !== 'data') patch.data = contaValorColuna('data', c.data)
    await contasRepo.update(c.id, patch)
  } catch (e) {
    toast('Erro ao salvar', true)
  }
}

// Propaga o erro para a buildTable fazer o rollback da exclusão.
async function remover(c) {
  if (c.id) await contasRepo.remove(c.id)
}

// Monta apenas a tabela (sem recalcular KPIs/filtros).
function contasTable() {
  buildTable({
    data: state.contas,
    bodyId: 'contasBody',
    countId: 'contasCount',
    search: contasSearch,
    searchFields: ['conta', 'gestor', 'offer', 'bm', 'situacao', 'observacoes'],
    filter: contasFilterFn,
    dateCol: 'data',
    stamp,
    cols: [
      { field: 'tipo', type: 'select', opts: ['', ...TIPO_OPTS] },
      { field: 'conta' },
      { field: 'bm', cls: 'wide' },
      { field: 'gestor', type: 'select', opts: ['', ...GESTOR_OPTS] },
      { field: 'offer', type: 'dynselect', cls: 'wide', optsFn: ofertasIds },
      { field: 'status', type: 'status', opts: SIT_OPTS },
      { field: 'qualidade', type: 'status', opts: QUAL_OPTS },
      { field: 'situacao', type: 'status', opts: STATUS_OPTS },
      { field: 'data', type: 'readonly' },
      { field: 'observacoes', cls: 'wide' }
    ],
    onPersist: persistir,
    onDelete: remover,
    rerender: contasTable,
    onChange: refreshContasMeta
  })
}

// Recalcula KPIs e (re)monta os 5 dropdowns com suas contagens.
function refreshContasMeta() {
  const d = state.contas
  const cnt = (campo, norm) => {
    const o = {}
    d.forEach(c => {
      let v = (c[campo] || '').trim()
      if (norm) v = norm(v)
      if (v) o[v] = (o[v] || 0) + 1
    })
    return o
  }
  const stC = cnt('situacao'),
    geC = cnt('gestor'),
    quC = cnt('qualidade')
  const ativ = d.filter(c => (c.status || '').trim().toUpperCase() === 'ATIVO').length
  document.getElementById('contasKpis').innerHTML =
    kpiHTML('Total de contas', d.length, '', '') +
    kpiHTML('Ativas', ativ, '', 'g') +
    kpiHTML('Gestores', Object.keys(geC).length, '', 'b') +
    kpiHTML('Com bug', quC['Com bug'] || 0, '', quC['Com bug'] ? 'r' : '')

  const sitCounts = { ATIVO: 0, CAIU: 0, PAUSADA: 0 }
  d.forEach(c => {
    const v = (c.status || '').trim().toUpperCase()
    if (v === 'ATIVO') sitCounts['ATIVO']++
    else if (v === 'CAIU') sitCounts['CAIU']++
    else if (v === 'PAUSADA') sitCounts['PAUSADA']++
  })
  const tipoCounts = { Normal: 0, Alugada: 0 }
  d.forEach(c => {
    const v = (c.tipo || '').trim().toLowerCase()
    if (v === 'normal') tipoCounts['Normal']++
    else if (v === 'alugada') tipoCounts['Alugada']++
  })
  drop('contasSitDrop', 'Todas as situações', fSit, sitCounts, SIT_OPTS, v => {
    fSit = v
    renderContas()
  })
  drop('contasTipoDrop', 'Todos os tipos', fTipo, tipoCounts, TIPO_OPTS, v => {
    fTipo = v
    renderContas()
  })
  drop('contasGestorDrop', 'Todos os gestores', fGestor, geC, GESTOR_OPTS, v => {
    fGestor = v
    renderContas()
  })
  drop('contasStatusDrop', 'Todos os status', fStatus, stC, STATUS_OPTS, v => {
    fStatus = v
    renderContas()
  })
  drop('contasQualDrop', 'Todas as qualidades', fQual, quC, QUAL_OPTS, v => {
    fQual = v
    renderContas()
  })
}

export function renderContas() {
  refreshContasMeta()
  contasTable()
}

// Liga busca e botão de adicionar (uma vez no boot).
export function ligarContas() {
  document.getElementById('contasSearch').oninput = e => {
    contasSearch = e.target.value
    contasTable()
  }
  document.getElementById('addConta').onclick = async () => {
    const nova = {
      id: crypto.randomUUID(),
      conta: '',
      bm: '',
      tipo: 'Normal',
      offer: '',
      gestor: '',
      situacao: 'Aquecer',
      qualidade: '',
      status: 'ATIVO',
      data: hojeBR(),
      observacoes: '',
      posicao: posicaoTopo(state.contas)
    }
    state.contas.unshift(nova)
    renderContas()
    try {
      const salva = await contasRepo.insert(nova)
      nova.id = salva.id
      toast('Conta adicionada')
    } catch (e) {
      const i = state.contas.indexOf(nova) // rollback: insert falhou
      if (i !== -1) state.contas.splice(i, 1)
      renderContas()
      toast('Erro ao salvar — conta não criada', true)
    }
  }
}

// Evento realtime para a área.
export function onExternalChange() {
  renderContas()
}
